// Scripts for product results page items

// Sets product result block height to be equal
function productHeight() {
    const resultOptions = Array.from(
        document.querySelectorAll(".m-resultOption")
    );

    if (resultOptions.length > 0) {
        let height = 0;

        resultOptions.forEach((resultOption) => {
            if (resultOption.offsetHeight > height) {
                height = resultOption.offsetHeight;
            }
        });

        resultOptions.forEach((resultOption) => {
            resultOption.style.height = `${height}px`;
        });
    }
}

document.addEventListener("DOMContentLoaded", function () {
    productHeight();
    window.addEventListener("resize", function () {
        productHeight();
    });
});
